import { FC, memo } from 'react';
import { Table } from 'shared/ui/Table';
import { UserListItem } from 'entities/users';
import { UserRequestDto } from 'shared/api';
import { USER_TABLE_COLUMNS } from '../../constants/userConstants';

interface UserTableProps {
  users: UserListItem[];
  onEdit: (user: UserListItem) => void;
  onDelete: (id: number, data: UserRequestDto) => void;
}

export const UserTable: FC<UserTableProps> = memo(({
  users,
  onEdit,
  onDelete,
}) => {
  const actions = [
    {
      key: 'edit',
      label: 'Редактировать',
      onClick: (record: UserListItem) => onEdit(record),
    },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: (record: UserListItem) => onDelete(record.id!, record),
      danger: true,
    },
  ];

  return (
    <Table
      columns={USER_TABLE_COLUMNS}
      dataSource={users}
      rowKey="id"
      hasPagination
      actions={actions}
    />
  );
});

UserTable.displayName = 'UserTable';
